export const sendPostRequest = async (url: string, data: any | undefined) => {
  const response = await fetch(url, {
    method: "POST",
    body: JSON.stringify(data)
  });
  return await response.json();
}
